import { FC, ReactElement } from 'react';

import { Box, SxProps, Typography } from '@mui/material';

import { Flex } from '../Flex';

interface PillarHeader {
    heading: string;
    subheading?: string;
    componentRight?: ReactElement;
    sx?: SxProps;
}

export const PillarHeader: FC<PillarHeader> = ({ heading, subheading, componentRight, sx }) => {
    return (
        <Flex
            alignItems="center"
            justifyContent="space-between"
            border="#FEE380 solid 1px"
            borderRadius="16px"
            padding="24px 16px"
            boxShadow="0px 4px 20px 0px #2632381A"
            sx={sx}
        >
            <Box>
                <Typography fontSize="24px" lineHeight="34px" fontWeight="700" color="#1D1D1B">
                    {heading}
                </Typography>
                {subheading && (
                    <Typography fontSize="21px" fontWeight="400" lineHeight="30px" color="#F39E4E">
                        {subheading}
                    </Typography>
                )}
            </Box>
            {componentRight}
        </Flex>
    );
};
